module.exports = {
  finance_inputBusinessNumber: 'Vui lòng nhập số nghiệp vụ',
  finance_query: 'Truy vấn',
  finance_view: 'Xem',
  finance_returnQuery: 'Quay lại truy vấn',
  finance_batchAudit: 'Duyệt hàng loạt',
  finance_lockTheBill: 'Khóa đơn',
  finance_accrue: 'Trích lập',
  finance_businessCommission: 'Hoa hồng nghiệp vụ',
  finance_cancelAccrue: 'Hủy trích lập',
  finance_print: 'In',
  finance_audit: 'Duyệt',
  finance_cancelTheAudit: 'Hủy duyệt',
  finance_chargesAudit: 'Duyệt chi phí',
  finance_cancelTheChargesAudit: 'Hủy duyệt chi phí',
  finance_printTheProfit: 'In lợi nhuận',
  finance_editFinancialDate: 'Sửa ngày tài chính',
  finance_businessAdjustment: 'Điều chỉnh nghiệp vụ',
  finance_editChargeFinancialDate: 'Sửa ngày tài chính chi phí',
  finance_basic: 'Cơ bản',
  finance_booking: 'Đặt chỗ',
  finance_charges: 'Chi phí',
  finance_domesticBill: 'Hóa đơn nội địa',
  finance_internationalBill: 'Hóa đơn quốc tế',
  finance_collectAndPrepaid: 'Thu hộ ứng trước',
  finance_fileHistory: 'Lịch sử tệp',
  finance_exportExcelAll: 'Xuất tất cả',
  finance_updateBusinessDate: 'Sửa ngày nghiệp vụ',
  finance_log: 'Nhật ký',
  finance_allowChange: 'Cho phép sửa đơn',
  finance_checkChange: 'Duyệt sửa đơn',
  finance_batchCheckChange: 'Duyệt sửa đơn hàng loạt',
  finance_revokeChangeCommit: 'Rút lại yêu cầu sửa đơn',
  charge_receivables: 'Phải thu',
  charge_equivalent: 'Quy đổi',
  charge_inviteToConfirmTheCharges: 'Mời xác nhận chi phí',
  charge_newAdjustment: 'Thêm điều chỉnh',
  charge_editAdjustment: 'Sửa điều chỉnh',
  charge_deleteAdjustment: 'Xóa điều chỉnh',
  charge_writeOffList: 'Chi tiết thanh toán',
  charge_chargesReject: 'Từ chối chi phí',
  charge_chargeItem: 'Tên chi phí',
  charge_settleAccountsTo: 'Đối tượng thanh toán',
  charge_invoiceHeader: 'Tiêu đề hóa đơn',
  charge_somesticOrInternational: 'Nội địa/Quốc tế',
  charge_drawABillOrNot: 'Cần xuất hóa đơn không',
  charge_currency: 'Loại tiền',
  charge_localCurrency: 'Loại tiền gốc',
  charge_exchangeRate: 'Tỷ giá',
  charge_unit: 'Đơn vị',
  charge_amount: 'Số lượng',
  charge_unitPrice: 'Đơn giá',
  charge_taxIncludedPrice: 'Giá bao gồm thuế',
  charge_taxExcludedPrice: 'Giá chưa bao gồm thuế',
  charge_taxRate: 'Thuế suất',
  charge_whtTaxRate: 'Thuế suất WHT',
  charge_payables: 'Phải trả',
  charge_controlled: 'Kiểm soát',
  charge_cancelControlled: 'Hủy kiểm soát',
  charge_taxAmount: 'Số tiền thuế',
  charge_whtTaxAmount: 'Tiền thuế WHT',
  charge_whtTaxLocalAmount: 'Tiền thuế WHT (tiền tệ gốc)',
  charge_notWhtAmount: 'Khấu trừ WHT',
  charge_remarks: 'Ghi chú',
  charge_contactPerson: 'Người liên hệ',
  charge_relatedBLNo: 'Số vận đơn liên quan',
  charge_relatedContainerNo: 'Số container liên quan',
  charge_freightCollectOrPrepaid: 'Trả trước/trả sau',
  charge_status: 'Trạng thái',
  charge_conversionRMB: 'Quy đổi sang RMB',
  charge_confirmOrNot: 'Đã xác nhận chưa?',
  charge_billNo: 'Số hóa đơn',
  charge_agent_billNo: 'Số hóa đơn chia sẻ đại lý',
  charge_containerNo: 'Số container',
  charge_invoiceNo: 'Số hóa đơn',
  charge_invoiceDate: 'Ngày lập hóa đơn',
  charge_agentBillNo: 'Số hóa đơn đối tác',
  charge_theAmountOfWriteOffs: 'Số tiền đối chiếu',
  charge_writeOffDate: 'Ngày thanh toán',
  charge_financialDate: 'Ngày kế toán',
  charge_businessNumber: 'Mã nghiệp vụ',
  charge_creator: 'Người tạo',
  charge_createTime: 'Thời gian tạo',
  charge_editor: 'Người sửa',
  charge_editTime: 'Thời gian sửa',
  charge_paymentApplicationNo: 'Số yêu cầu thanh toán',
  charge_profit: 'Lợi nhuận',
  charge_profitAll: 'Tổng lợi nhuận',
  charge_estimateRemarks: 'Ghi chú dự toán',
  charge_showRedCharges: 'Hiển thị chi phí điều chỉnh',
  charge_auditor: 'Người duyệt',
  charge_estimate: 'Dự toán',
  charge_add: 'Thêm mới',
  charge_copy: 'Sao chép chi phí',
  charge_delete: 'Xóa',
  charge_edit: 'Sửa',
  charge_chargesAudit: 'Duyệt chi phí',
  charge_cancelTheAudit: 'Hủy duyệt',
  charge_showCommonCharge: 'Hiển thị chi phí thông thường',
  charge_showSpecialCharge: 'Hiển thị chi phí đặc biệt',
  charge_sp1: 'Mã cước vận chuyển',
  charge_sp2: 'Nhấp để sao chép số bảng giá cước',
  charge_sp3: 'Thêm mới theo dịch vụ',
  charge_sp4: 'Cập nhật tỷ giá',
  charge_sp5: 'Sao chép chi phí hóa đơn nhỏ',
  charge_sp6: 'Sao chép khoản phải trả',
  charge_sp7: 'Phương án chi phí',
  charge_sp8: 'Bảng giá cước',
  charge_sp9: 'Hủy nộp',
  charge_sp10: 'Nộp chi phí',
  charge_sp11: 'Phân bổ chi phí',
  charge_sp12: 'Hiển thị chi phí chia hóa đơn',
  charge_sp13: 'Hạng mục dịch vụ',
  charge_copyCost: 'Sao chép khoản phải thu',
  charge_copyCharge: 'Sao chép chi phí',
  charge_payReceiveDate: 'Ngày thu/chi',
  charge_actualAmountNo: 'Số serial đối soát',
  charge_newChange: 'Thêm phí sửa đơn',
  charge_editChange: 'Sửa phí sửa đơn',
  charge_deleteChange: 'Xóa phí sửa đơn',
  charge_shared: 'Phân bổ',
  charge_showSharedCharges: 'Hiển thị chi phí phân bổ',
  charge_newSpecial: 'Thêm chi phí đặc biệt',
  charge_editSpecial: 'Chỉnh sửa chi phí đặc biệt',
  charge_unitPriceIncludeTax: 'Đơn giá đã bao gồm thuế chưa',
  charge_locked_status: 'Đã khóa hay chưa',
  domestic_showAllBilling: 'Hiển thị tất cả hóa đơn',
  domestic_commissionedChargesOnly: 'Chỉ hiển thị chi phí ủy thác này',
  domestic_newReceivables: 'Tạo mới khoản phải thu',
  domestic_newPayables: 'Tạo mới khoản phải trả',
  domestic_edit: 'Chỉnh sửa',
  domestic_delete: 'Xóa',
  domestic_view: 'Xem',
  domestic_confirm: 'Xác nhận',
  domestic_cancelConfirm: 'Hủy xác nhận',
  domestic_billNo: 'Số hóa đơn',
  domestic_settleAccountTto: 'Đối tượng thanh toán',
  domestic_settlementAgent: 'Đại lý thanh toán',
  domestic_invoiceHeader: 'Người nhận hóa đơn',
  domestic_currency: 'Loại tiền tệ',
  domestic_chargeAmount: 'Số tiền',
  domestic_totalCurrency: 'Tổng theo loại tiền',
  domestic_revenueAndExpenditureType: 'Loại thu chi',
  domestic_confirmationStatus: 'Trạng thái xác nhận',
  domestic_invoicingStatus: 'Trạng thái xuất hóa đơn',
  domestic_writeOffStatus: 'Trạng thái đối soát',
  domestic_revenueOrExpenditure: 'Thu chi',
  domestic_chargeItem: 'Tên chi phí',
  domestic_unit: 'Đơn vị',
  domestic_amount: 'Số lượng',
  domestic_unitPrice: 'Đơn giá',
  domestic_taxIncludedPrice: 'Giá bao gồm thuế',
  domestic_taxExcludedPrice: 'Giá chưa bao gồm thuế',
  domestic_taxRate: 'Thuế suất',
  domestic_taxAmount: 'Số tiền thuế',
  domestic_remarks: 'Ghi chú',
  domestic_billingGroupNo: 'Số đối chiếu',
  domestic_billingBranchId: 'Chi nhánh quản lý hóa đơn',
  international_showAllBilling: 'Hiển thị tất cả hóa đơn',
  international_commissionedChargesOnly: 'Chỉ hiển thị chi phí ủy thác này',
  international_add: 'Thêm mới',
  international_edit: 'Chỉnh sửa',
  international_delete: 'Xóa',
  international_audit: 'Duyệt',
  international_invalid: 'Hủy bỏ',
  international_agentProfitShareBillNo: 'Hóa đơn chia phần đại lý',
  international_printAllAgentProfitShareBillNo: 'In tất cả hóa đơn chia phần đại lý',
  international_editAgentBillNo: 'Chỉnh sửa số hóa đơn đối tác',
  international_billNo: 'Số hóa đơn',
  international_agentBillNo: 'Số hóa đơn đối tác',
  international_revenueAndExpenditureType: 'Loại thu chi',
  international_settleAccountTo: 'Đối tượng thanh toán',
  international_settlementAgent: 'Đại lý thanh toán',
  international_currency: 'Loại tiền tệ',
  international_chargeAmount: 'Số tiền',
  international_status: 'Trạng thái',
  international_billType: 'Loại hóa đơn',
  international_invoicingStatus: 'Trạng thái xuất hóa đơn',
  international_writeOffStatus: 'Trạng thái đối soát',
  international_billDtae: 'Ngày hóa đơn',
  international_creator: 'Người tạo',
  international_businessNumber: 'Mã nghiệp vụ',
  international_billingGroupNo: 'Số đối chiếu',
  international_revenueOrExpenditure: 'Thu chi',
  international_chargeItem: 'Tên chi phí',
  international_taxIncludedPrice: 'Giá bao gồm thuế',
  international_taxExcludedPrice: 'Giá chưa bao gồm thuế',
  international_taxRate: 'Thuế suất',
  international_taxAmount: 'Số tiền thuế',
  international_unit: 'Đơn vị',
  international_amount: 'Số lượng',
  international_unitPrice: 'Đơn giá',
  international_remarks: 'Ghi chú',
  adChargeInfo_prepaid: 'Tạm ứng',
  adChargeInfo_print: 'In',
  adChargeInfo_newAdjustment: 'Thêm điều chỉnh',
  adChargeInfo_editAdjustment: 'Sửa điều chỉnh',
  adChargeInfo_deleteAdjustment: 'Xóa điều chỉnh',
  adChargeInfo_addBoth: 'Thêm đồng thời',
  adChargeInfo_add: 'Thêm mới',
  adChargeInfo_delete: 'Xóa',
  adChargeInfo_chargeItem: 'Tên chi phí',
  adChargeInfo_settleAccountsTo: 'Đối tượng thanh toán',
  adChargeInfo_domesticOrInternational: 'Nội địa/Nước ngoài',
  adChargeInfo_currency: 'Loại tiền tệ',
  adChargeInfo_unit: 'Đơn vị',
  adChargeInfo_quantity: 'Số lượng',
  adChargeInfo_unitPrice: 'Đơn giá',
  adChargeInfo_exchangeRate: 'Tỷ giá',
  adChargeInfo_amount: 'Số tiền',
  adChargeInfo_remarks: 'Ghi chú',
  adChargeInfo_billNo: 'Số hóa đơn',
  adChargeInfo_taxNo: 'Mã số thuế',
  arChargeInfo_theAmountOfWriteOffs: 'Số tiền đối chiếu',
  apChargeInfo_theAmountOfWriteOffs: 'Số tiền đối chiếu',
  adChargeInfo_collect: 'Thu hộ',
  adChargeInfo_submitCharge: 'Gửi chi phí',
  adChargeInfo_cancelSubmit: 'Hủy gửi',
  adChargeInfo_status: 'Trạng thái',
  adChargeInfo_paymentApplicationNo: 'Số yêu cầu thanh toán',
  international_forceDelete: 'Xóa cưỡng chế',
  return: 'Quay lại',
  Confirm: 'Xác nhận',
  Cancel: 'Hủy',
  accrualDate: 'Ngày trích lập',
  adjustmentItem: 'Mục điều chỉnh',
  adjustmentValue: 'Giá trị điều chỉnh',
  charge_ProvisionedDate: 'Ngày trích lập',
  charge_specialUpdate: 'Điều chỉnh chi phí đặc biệt',
  charge_settleDepartmentPrefix: 'Bộ phận thanh toán',
  charge_paymentApplicationDateCreated: 'Ngày tạo phiếu yêu cầu thanh toán',
  charge_SapStatus: 'Trạng thái SAP',
  finance_ChargeCommit: 'Gửi sửa đơn',
  separateAllocation: 'Tình hình phân bổ đơn hàng',
  allocationType: 'Loại phân bổ',
  costSharingValue: 'Giá trị phân bổ chi phí',
  modifyField: 'Sửa trường dữ liệu',
  operationContent: 'Nội dung thao tác',
  statusAfterOperation: 'Trạng thái sau thao tác',
  routeLeader: 'Người phụ trách tuyến',
  selectAdjustmentItem: 'Vui lòng chọn mục điều chỉnh',
  businessInfoAdjustedSuccess: 'Điều chỉnh thông tin nghiệp vụ thành công',
  apportionedTax: 'Phân bổ số thuế',
  charge_asyncCharges: 'Đồng bộ chi phí',
  charge_asyncChargeRecords: 'Lịch sử đồng bộ chi phí',
  lockBusinessSuccess: 'Khóa đơn thành công',
  AccountVerifyBusinessSuccess: 'Duyệt thành công',
  AccrualSucceeded: 'Trích lập thành công',
  charge_asyncChargesToImportJob: 'Đồng bộ sang nghiệp vụ nhập khẩu',
  charge_syncChargesConfirmStatus: 'Trạng thái đồng bộ chi phí',
  charge_cancelSyncChargesConfirmStatus: 'Hủy trạng thái đồng bộ chi phí',
  charge_syncChargesToSI: 'Đồng bộ chi phí chuyển nhập khẩu',
  charge_cancelSyncChargesToSI: 'Hủy đồng bộ chi phí chuyển nhập khẩu',
  charge_paymentAmount: 'Số tiền thu/chi',
  expenseSharingReceipt: 'Phiếu phân bổ chi phí',
  correspondingAllocationBusiness: 'Nghiệp vụ phân bổ tương ứng',
  allocateRelatedBusinesses: 'Nghiệp vụ liên quan phân bổ',
  BusinessSyncModifyBusinessDate: 'Nghiệp vụ xuất khẩu sẽ đồng bộ sửa ngày nghiệp vụ',
  ImportBusinessSyncModifyBusinessDate: 'Nghiệp vụ nhập khẩu sẽ đồng bộ sửa ngày nghiệp vụ',
  ExportBusinessItemCannotEmpty: 'Nghiệp vụ xuất khẩu không được để trống mục này',
  ImportBusinessItemCannotEmpty: 'Nghiệp vụ nhập khẩu không được để trống mục này',
  LandTransportationBusinessItemCannotEmpty: 'Nghiệp vụ vận tải đường bộ không được để trống mục này',
  synchronizationFeesToBeProcessed: 'Chi phí đồng bộ chờ xử lý',
  markAsRead: 'Đánh dấu đã đọc',
  fail: 'Không duyệt',
  applyRecallCharge: 'Yêu cầu thu hồi chi phí',
  recallState: 'Trạng thái thu hồi',
  recallCause: 'Lý do thu hồi',
  youCanOnlyOperateOnConfirmedCharges: 'Chỉ được thao tác với chi phí đã xác nhận',
  thereAreCostsThatHaveBeenWithdrawn: 'Đã tồn tại chi phí bị thu hồi, vui lòng không gửi lại',
  theFeeHasEnteredTheSettlementProcess: 'Chi phí đã vào khâu thanh toán, không thể thu hồi. Cần hủy liên kết từ các chứng từ như xác nhận đối chiếu, hóa đơn, phiếu thanh toán, bản ghi xóa nợ...',
  PleaseSeparateTheFeesForConfirmationAndWithdrawal: 'Vui lòng thao tác riêng chi phí chờ xác nhận lần đầu và yêu cầu thu hồi',
  receivablePayable: 'Phải thu/Phải trả',
  currency: 'Loại tiền',
  sender: 'Bên gửi',
  receiver: 'Bên nhận',
  syncProgress: 'Tiến độ đồng bộ',
  processingStatus: 'Trạng thái xử lý',
  sendingTime: 'Thời gian gửi',
  auditOperationTime: 'Thời gian thao tác duyệt',
  pending: 'Chờ xử lý',
  alreadyRead: 'Đã đọc',
  notRead: 'Chưa đọc',
  businessHasBeenSubmitted: 'Nghiệp vụ đã nộp, không thể duyệt và thêm chi phí. Nếu cần, vui lòng liên hệ quản lý để hủy nộp.',
  selectBeConfirmedChargeByUs: 'Vui lòng chọn chi phí chờ bên tôi xác nhận',
  selectRejectedChargeByOppositeParty: 'Vui lòng chọn chi phí đã bị đối tác từ chối',
  pleaseSaveTheCurrentPageFirst: 'Vui lòng lưu trang hiện tại trước',
  commissionAmount: 'Số tiền hoa hồng',
  charge_writeOffDate_ar: 'Ngày xóa nợ',
  charge_writeOffDate_ap: 'Ngày xóa nợ',
  GenerateVoucher: 'Đã tạo chứng từ chưa?',
  CurrencyAccountsReceivable: 'Phải thu theo loại tiền:',
  CurrencyAccountsPayable: 'Phải trả theo loại tiền:',
  today: 'Trong ngày',
  thisMonthEnd: 'Cuối tháng này',
  previousMonthEnd: 'Cuối tháng trước',
  IssueMonthOfYear: 'Kỳ {1} năm {0}',
  QMonthYear: 'Quý {1} năm {0}',
  XYear: 'Năm {0}',
  SongtiSerif: 'Font Song, serif',
  TrialBalance: 'Bảng cân đối tài khoản',
  BalanceSheetWithContacts: 'Bảng số dư tạm ứng',
  StatementOfAccountWithContacts: 'Sổ đối chiếu tạm ứng',
  SubsidiaryLedger: 'Sổ chi tiết',
  GeneralLedger: 'Sổ cái',
  Receive: 'Thu',
  Pay: 'Chi',
  Transfer: 'Chuyển',
  ForeignCurrencyRevaluation: 'Điều chỉnh tỷ giá cuối kỳ',
  RetainedEarnings: 'Kết chuyển lãi lỗ kỳ này',
  Billion: 'Tỷ',
  Thousand: 'Nghìn',
  Hundred: 'Trăm',
  Ten: 'Mười',
  TenThousand: 'Vạn',
  Yuan: 'Nguyên',
  Dime: 'Hào',
  Cent: 'Phân',
  FailedObtainCurrentFiscalPeriod: 'Lấy kỳ kế toán hiện tại thất bại!',
  Total: 'Tổng cộng',
  Quantity: 'Số lượng:',
  UnitPrice: 'Đơn giá:',
  ForeignCurrency: 'Tiền gốc:',
  UnbalancedDebitAndCreditEntry: 'Nhập liệu nợ có không cân bằng!',
  ThisVoucherPleaseEditInModule: '此凭证是业务凭证\n请至“生成凭证”模块编辑',
  ForeignCurrencyCannotBeEmpty: 'Tiền gốc không được để trống',
  ClientItemCannotBeEmpty: 'Mục phụ khách hàng không được để trống',
  SupplierItemCannotBeEmpty: 'Mục phụ nhà cung cấp không được để trống',
  StaffItemCannotBeEmpty: 'Mục phụ nhân viên không được để trống',
  ProjectItemCannotBeEmpty: 'Mục phụ dự án không được để trống',
  DepartmentItemCannotBeEmpty: 'Mục phụ phòng ban không được để trống',
  Client: 'Khách hàng',
  Supplier: 'Nhà cung cấp',
  Department: 'Phòng ban',
  Staff: 'Nhân viên',
  Project: 'Dự án',
  Currency: 'Loại tiền:',
  Amount: 'Số tiền:',
  ExchangeRate: 'Tỷ giá:',
  All: 'Tất cả',
  Yes: 'Có',
  No: 'Không',
  Year: 'Năm',
  Period: 'Kỳ',
  PleaseSelectVoucherRange: 'Vui lòng chọn khoảng chứng từ',
  Assets: 'Tài sản',
  Liabilities: 'Nợ phải trả',
  Equity: 'Vốn chủ sở hữu',
  Cost: 'Chi phí',
  ProfitAndLoss: 'Lãi lỗ',
  ClientSupplier: 'Khách hàng/Nhà cung cấp',
  BalanceInRMB: 'Số dư nhân dân tệ',
  UnmatchedClientOrSupplier: 'Khách hàng hoặc nhà cung cấp chưa khớp',
  AddAssetAccount: 'Thêm tài khoản loại tài sản',
  Add: 'Thêm mới',
  Edit: 'Chỉnh sửa',
  Delete: 'Xóa',
  AddCashFlowItem: 'Thêm dự án dòng tiền',
  ImportSucceeded: 'Nhập thành công',
  DesignSubaccounts: 'Thiết kế tài khoản con',
  NeedToExport: 'Cần xuất',
  NoExportNeeded: 'Không cần xuất',
  SeparatorSettings: 'Cài đặt ký tự phân cách',
  ExportSeparator: 'Ký tự phân cách khi xuất',
  Separator: 'Ký tự phân cách:',
  PleaseFinancialYearForReport: 'Vui lòng điền năm tài chính cần khởi tạo báo cáo,',
  RepeatingDataLossPleaseCaution: 'Khởi tạo lại sẽ làm mất dữ liệu đã được duy trì, vui lòng sử dụng cẩn thận.',
  InitializationPleaseCheckAccountSettings: 'Khởi tạo thành công, vui lòng kiểm tra cài đặt tài khoản.',
  InitializationPleaseCheckTheReport: 'Khởi tạo thành công, vui lòng kiểm tra báo cáo.',
  DetailedEntryRulesConfiguration: 'Cấu hình quy tắc tóm tắt bút toán',
  FeeWillBeDeleted: 'Lưu ý: Sắp xóa {0} chi phí',
  AccountNotFound: 'Bộ sổ không tồn tại',
  Quarter: 'Quý',
  AccountingVoucher: 'Chứng từ kế toán',
  StatusUnknown: 'Trạng thái không xác định',
  N0Year0Period: 'Kỳ {1} năm {0}',
  SyncCloudSucceededXFailedX: 'Đồng bộ Cloud Star thành công {0} mục, thất bại {1} mục',
  SyncExceptionReason: 'Nguyên nhân đồng bộ bất thường',
  SyncCloudStarrySky: 'Đồng bộ Cloud Star',
  SyncFeeCannotSyncAgain: 'Chi phí đã đồng bộ không thể đồng bộ lại!',
  DisplayTransactions: 'Hiển thị nghiệp vụ đối ứng',
  EnterBusinessNumberBeforeQuery: 'Vui lòng nhập số nghiệp vụ trước khi tra cứu',
  SelectNewEncodingType: 'Chọn loại mã mới',
  SelectMatchingPartnerFieldType: 'Chọn loại trường đối tác khớp',
  NewEncodingType: 'Loại mã mới:',
  CustomerCode: 'Mã khách hàng',
  SupplierCode: 'Mã nhà cung cấp',
  AtLeastOneCustomerAndSupplierCode: 'Phải chọn ít nhất một trong mã khách hàng hoặc mã nhà cung cấp',
  MatchPartnerFieldTypes: 'Loại trường đối tác khớp:',
  PartnersCode: 'Đối tác_Mã',
  PartnersNumber: 'Đối tác_Số',
  PartnersChineseName: 'Đối tác_Tên tiếng Trung',
  ImportCustomerAndProviderCode: 'Xác nhận nhập [{0}] làm mã khách hàng và nhà cung cấp cho đối tác của bộ sổ này?',
  ImportCustomerCode: 'Xác nhận nhập [{0}] làm mã khách hàng cho đối tác của bộ sổ này?',
  ImportProviderCode: 'Xác nhận nhập [{0}] làm mã nhà cung cấp cho đối tác của bộ sổ này?',
  ImportCodePenddingTip: 'Đang nhập mã khách hàng/nhà cung cấp...<br>Rời khỏi trang hiện tại sẽ không ảnh hưởng đến quá trình nhập, bạn sẽ được thông báo khi hoàn tất.',
  ModifyExpirationDate: 'Sửa ngày đáo hạn',
  ModifyChargeExpirationDate: 'Sửa ngày đáo hạn chi phí',
  RemoveCountFee: 'Vui lòng loại bỏ chi phí đã tính',
  ChargeHqCurrency: 'Tiền tệ địa phương HQ',
  ChargeHqRate: 'Tỷ giá tiền tệ địa phương HQ',
  CostType: 'Loại chi phí',
  HideForeignCurrencyProfitLoss: 'Không hiển thị kết chuyển lãi lỗ ngoại tệ',
  GpExplain: 'Giải thích GP',
  Peer: 'Đơn vị ủy thác có phải cùng ngành không',
  ProfitRate: 'Tỷ suất lợi nhuận',
  ArRowsAndApRows: 'Số dòng phải thu/Số dòng phải trả',
  ArIncludeAp: 'Phải thu bao gồm phải trả',
  Allocation: 'Allocation',
  LclTicketsCanNotAudit: 'Phiếu lẻ hàng ghép không thể duyệt riêng, vui lòng duyệt phiếu chính.',
  SelectedDataJobSubmitNotAllowAudit: 'Dữ liệu được chọn có người gửi nghiệp vụ trùng với người duyệt hiện tại, không cho phép duyệt, vui lòng kiểm tra!',
  SelectedDataJobSubmitNotAllowCancelAudit: 'Dữ liệu được chọn có người gửi trùng với người duyệt hiện tại, không cho phép hủy duyệt, vui lòng kiểm tra!',
  SelectedDataChargeByNotAllowCancelAudit: 'Dữ liệu được chọn có người gửi chỉnh sửa trùng với người duyệt hiện tại, không cho phép duyệt, vui lòng kiểm tra!',
  JobSubmitNotAllowAudit: 'Người gửi nghiệp vụ trùng với người duyệt hiện tại, không cho phép duyệt!',
  JobSubmitNotAllowCancelAudit: 'Người gửi nghiệp vụ trùng với người duyệt hiện tại, không cho phép hủy duyệt!',
  JobSubmitNotAllowCancelChangeOrder: 'Người gửi nghiệp vụ trùng với người duyệt hiện tại, không thể cho phép chỉnh sửa!',
  ChargeSubmitNotAllowAudit: 'Người gửi chi phí trùng với người duyệt hiện tại, không cho phép duyệt!',
  ChargeSubmitNotAllowCancelAudit: 'Người gửi chi phí trùng với người duyệt hiện tại, không cho phép hủy duyệt chi phí!',
  ChargeSubmitNotAllowCancelChangeOrder: 'Người gửi chi phí trùng với người duyệt hiện tại, không cho phép duyệt chỉnh sửa!',
  AdditionalCostRemarks: 'Ghi chú chi phí bổ sung',
  AdditionalCostRemarksContent: 'Nội dung ghi chú chi phí bổ sung',
  JobSubmitNotAllowCancelAdjustCosts: 'Người gửi nghiệp vụ trùng với người duyệt hiện tại, không thể cho phép điều chỉnh chi phí!'
}
